import {
    ViewFactory,
    ComponentManager,
} from 'radpresentation.htmlclient.defaultviewextensions';
import CreatePropertyGroupViewViewModel from '@/ViewModels/Views/CreatePropertyGroupViewViewModel';
import CreatePropertyGroupView from '@/Views/CreatePropertyGroupView';
class CreatePropertyGroupViewFactory extends ViewFactory {
    public viewModel: CreatePropertyGroupViewViewModel;
    public view: CreatePropertyGroupView;

    constructor(private params: any) {
        super(params);
    }

    public getRegion(): string {
        return 'Modal';
    }

    public getView(): JQuery<HTMLElement> {
        if (!this.viewModel) {
            this.viewModel = new CreatePropertyGroupViewViewModel({
                callback: this.params.callback,
                takenNames: this.params.takenNames,
                locator: this.params.locator,
                viewFactory: this,
            });
        }

        if (!this.view) {
            this.view = new CreatePropertyGroupView(
                this.viewModel,
                this.createRootElement('CreatePropertyGroupView')
            );
        }

        return this.view.getTuple().view;
    }
}

export default CreatePropertyGroupViewFactory;
ComponentManager.setFactory(
    'CreatePropertyGroup',
    CreatePropertyGroupViewFactory,
    'RADExtensionManagerHTMLViewExtension'
);
